var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"stroke-background fill-none","cx":"12","cy":"12","r":"9.3","key":0}),React.createElement("polyline",{"className":"stroke-foreground fill-none","points":"7,12.6 12.6,12.6 12.6,5.8 ","key":1})]);
}

Clock.defaultProps = {"version":"1.0","width":"24px","height":"24px","viewBox":"0 0 24 24","xmlSpace":"preserve"};

module.exports = Clock;

Clock.default = Clock;
